import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { SaleItemDisplayOrderService } from './sale-item-display-order.service';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { get } from 'jquery';

@Component({
  selector: 'app-item-class-display-order',
  templateUrl: './sale-item-display-order.component.html',
  styleUrl: './sale-item-display-order.component.scss',
  standalone: false
})
export class SaleItemDisplayOrderComponent implements OnInit {

  menuList: any[] = []; // Fill this with your API data
  filteredMenuDepartments: any[] = [];

  itemRows: any[] = [];
  dropLists: string[] = []; // hold connected drop list ids
  menuDepartmentControl: FormControl<string | null>;
  itemClassForm!: FormGroup;

  subClassControl :FormControl<string | null>;
  itemSubClasses: any[] = []; // Should be array of { id, name, ... }
  filteredSubClasses: Observable<any[]> | undefined;

  isFormDirty: boolean = false;
  lastConfirmedSubClassId: number | null = null;
  subClassId: any;
  numberOfColumns: number = 5 + 1; // Default number of columns, can be changed based on requirements
  subClassInitialized: boolean = false;
  menuId: any;
  saleItemDisplayList: any;
  message: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private builder: FormBuilder,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private saleItemDisplayOrderService: SaleItemDisplayOrderService,
  ) {
    this.itemClassForm = this.builder.group({
      menu_department: this.builder.control('', [Validators.required, this.menuDepartmentValidator]),
      sub_class: this.builder.control('', [Validators.required,this.subClassValidator]),
      number_of_columns: this.builder.control('')
    });

    this.menuDepartmentControl = this.itemClassForm.get('menu_department') as FormControl;
    this.subClassControl = this.itemClassForm.get('sub_class') as FormControl;
    this.itemClassForm.valueChanges.subscribe(() => {
      // this.isFormDirty = true;
    });

  }

  ngOnInit() {
    this.getMenuList();

    this.menuDepartmentControl.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          //  this.isFormDirty = true;
          return this._filterMenuDepartments(value);
        })
      )
      .subscribe(filtered => this.filteredMenuDepartments = filtered);

    this.menuDepartmentControl.valueChanges.subscribe((selectedMenu: any) => {
      this.subClassControl.setValue('');
      const selectedMenuId = typeof selectedMenu === 'object' ? selectedMenu?.id : null;
      if (!selectedMenuId) return;

      const loadNewMenu = () => {
        this.subClassControl.setValue('');
        this.menuId = selectedMenuId;
        this.getSubClassList(selectedMenuId);
        this.isFormDirty = false;
        this.subClassInitialized = false;
      };

      if (this.isFormDirty && selectedMenuId !== this.menuId) {
        const message = `You have unsaved changes. Do you want to save before switching menu?`;
        const dialogData = new ConfirmDialogModel("Confirm Navigation", message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Save, then load new menu
            this.save();
            setTimeout(() => loadNewMenu(), 100); // Delay slightly to ensure save completes
          } else {
            // Discard and load new menu
            loadNewMenu();
          }
        });
      } else {
        // No unsaved changes, load directly
        loadNewMenu();
      }
      // this.menuId = selectedMenuId;
      // this.getSubClassList(selectedMenuId)
    });

    this.filteredSubClasses = this.subClassControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    this.subClassControl.valueChanges.subscribe((selectedSubClass: any) => {
      const selectedSubClassId = typeof selectedSubClass === 'object' ? selectedSubClass?.id : null;

      if (!selectedSubClassId) return;

      if (!this.subClassInitialized) {
        // First time selection — just load, don't prompt
        this.loadNewSubClass(selectedSubClassId);
        this.subClassInitialized = true;
        return;
      }

      if (this.isFormDirty && selectedSubClassId !== this.subClassId) {
        // alert('You have unsaved changes. Please save or discard them before switching menus.');
        // Prompt before switching
        const message = `You have unsaved changes. Do you want to save before switching?`;
        const dialogData = new ConfirmDialogModel("Confirm Navigation", message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Save first
            this.saveAndSwitch(selectedSubClassId);
          } else {
            // Discard and switch
            this.loadNewSubClass(selectedSubClassId);
          }
        });
      } else {
        this.loadNewSubClass(selectedSubClassId);
      }
    });
  }
  isDirty(): boolean {
    return this.isFormDirty;
  }

  loadNewSubClass(subClassId: number) {
    this.subClassId = subClassId;
    this.lastConfirmedSubClassId = subClassId;
    this.isFormDirty = false;
    this.itemClassDisplayOrderList(subClassId);
  }

  saveAndSwitch(menuId: number) {
    this.save();
    // Delay the load slightly after save to ensure it's processed
    setTimeout(() => {
      this.loadNewSubClass(menuId);
    }, 10);
  }
async navBack(): Promise<void> {
  if (this.isFormDirty) {
   const message = "Are you sure you want to discard your changes? Your changes will be lost.";
    const dialogData = new ConfirmDialogModel("Discard unsaved changes?", message);
    const result = await this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    }).afterClosed().toPromise();

    if (result) {
      this.completelyReset();
    }
    // If not confirmed, do nothing
  } else {
    this.completelyReset();
  }
}

completelyReset(): void {
  this.itemClassForm.reset();
  this.menuDepartmentControl.setValue('');
  this.subClassControl.setValue('');
  this.filteredMenuDepartments = this.menuList.slice();
  this.filteredSubClasses = of([]);
  this.menuId = null;
  this.subClassId = null;
  this.itemSubClasses = [];
  this.saleItemDisplayList = [];
  this.dropLists = [];
  this.message = '';
  this.isFormDirty = false;
}

  getMenuList() {
    let requestData: RequestData = {
      search: {
        filters: {
          scope: {
            limit: 1000,
            offset: 0
          }
        },
        sort: [
          {
            column: "name",
            order: "asc"
          }
        ]
      }
    }
    this.saleItemDisplayOrderService.getMenuDepartmentList(requestData).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.menuList = response.data.menus;
          this.filteredMenuDepartments = this.menuList;
        } else {
          console.error('Failed to load menu departments:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading menu departments:', error);
      }
    });
  }

  private _filterMenuDepartments(value: string | any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name?.toLowerCase() || '';
    return this.menuList.filter(dept => dept.name.toLowerCase().includes(filterValue));
  }

  private _filter(value: string | any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name?.toLowerCase() || '';
    return this.itemSubClasses.filter(item => item.name.toLowerCase().includes(filterValue));
  }


  displayMenuDepartmentName(dept: any): string {
    return dept && dept.name ? dept.name : '';
  }

  displaySubClass = (subclass: any): string => {
    return subclass && subclass.name ? subclass.name : '';
  };

  filterMenuDepartments() {
    // Optionally trigger filtering manually if needed
    this.filteredMenuDepartments = this._filterMenuDepartments(this.menuDepartmentControl.value);
  }

  clearMenuDepartment() {
    this.menuDepartmentControl.setValue('');
  }

  clearSubClass() {
    this.subClassControl.setValue('');
  }
  menuDepartmentValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null; // Allow empty (optional), or change as needed
    // If value is an object (selected from autocomplete), it's valid
    if (typeof value === 'object' && value.id) return null;
    // If value is a string, check if it matches any sale item name
    const match = this.menuList.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidMenuDepartment: true };
  };

  subClassValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;
    if (typeof value === 'object' && value.id) return null;
    const match = this.itemSubClasses.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidSubClass: true };
  };

  getSubClassList(menuId: number) {
    this.saleItemDisplayOrderService.getSubClassListByDepartmentId(menuId).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.itemSubClasses = response.data.itemClasses;
          this.filteredSubClasses = of(this.itemSubClasses);
        } else {
          console.error('Failed to load item class display order:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading item class display order:', error);
      }
    });
  }

  itemClassDisplayOrderList(subClassId: number) {
    const requestData = {
      menuId: this.menuId,
      subClassId: Number(subClassId)
    };
    this.saleItemDisplayOrderService.getSaleItemDisplayOrderBySubClassId(requestData).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.saleItemDisplayList = response.data.saleItemDisplayList;
          if (this.saleItemDisplayList.length == 0) {
            this.message = "No items found in this sub class";
          }else{
            this.message = "";
          }
        } else {
          console.error('Failed to load item class display order:', response.message);
        }
      },
      error: (error: any) => {
        console.error('API error when loading item class display order:', error);
      }
    });
  }

  save() {
    this.itemClassForm.markAllAsTouched();
    if (this.itemClassForm.invalid) {
      // Show errors or prevent save
      return;
    }
    this.menuDepartmentControl.markAsTouched();
    if (this.menuDepartmentControl.invalid) {
      return;
    }
    const newData = this.saleItemDisplayList;
    let requestData = {
      itemSubClasses: newData,
      subClassId: Number(this.subClassId),
      menuId: this.menuId, // Assuming menuDepartmentControl holds the selected menu object
    }

    this.saleItemDisplayOrderService.update(requestData).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          // handle success
          this.isFormDirty = false;
          let snckBarData: SnackBarData = {
            type: 'success',
            title: 'Saved',
            message: 'The sale item display order has been updated successfully.'
          }
          this.snackBarService.openSnackBar(snckBarData);
          // this.router.navigate(['/uom']);
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        // handle error
        let snackBarData: SnackBarData = {
          message: 'Failed to update. Connection to the server failed',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.saleItemDisplayList, event.previousIndex, event.currentIndex);
    this.isFormDirty = true;
    // console.log(this.itemSubClasses);
  }

}